import React from 'react';

import Badge from 'components/shared/Badge';
import SVGIcon from 'components/shared/SVGIcon';

const Phase = ({ objectiveDetail }) => {
  const { phase } = objectiveDetail || {};

  const { name, colorHex, bgColorHex } = phase || {};

  return (
    <div className="px-[24px]">
      <div className="h-[48px] flex items-center">
        <SVGIcon
          iconName="icon-phase_outlined"
          size="24"
          fillColor="var(--n-600)"
          customClass="mr-[16px]"
        />
        <Badge
          defaultPointer
          content={name}
          colorHex={colorHex}
          bgColorHex={bgColorHex}
          className="pointer-events-none"
        />
      </div>
    </div>
  );
};

export default Phase;
